import React from "react";
import { StarIcon, ReplyIcon, ArchiveIcon } from "lucide-react";
type Props = {
  name: string;
  email: string;
  subject: string;
  body: string;
  time: string;
  initials: string;
  color: string;
};
export function GmailReview({
  name,
  email,
  subject,
  body,
  time,
  initials,
  color
}: Props) {
  return <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-md" data-id="element-161" data-mp="3a7x07drubsmg">
      {/* Gmail top bar */}
      <div className="flex items-center gap-2 border-b border-slate-100 bg-slate-50 px-3 py-2" data-id="element-162" data-mp="2mh9iy1w1bqn8">
        <span className="h-3 w-3 rounded-full bg-red-400" data-id="element-163" data-mp="2hjrfus4p85n5" />
        <span className="h-3 w-3 rounded-full bg-yellow-400" data-id="element-164" data-mp="2v9l3560k2hur" />
        <span className="h-3 w-3 rounded-full bg-green-400" data-id="element-165" data-mp="2qimn87jhbls1" />
        <span className="ml-2 flex items-center gap-1 text-[11px] font-semibold text-slate-500" data-id="element-166" data-mp="2qh1tgk4zo6v8">
          <span className="text-red-500" data-id="element-167" data-mp="22rh6lq5pspgo">M</span> Gmail
        </span>
      </div>

      <div className="p-3" data-id="element-168" data-mp="1yqdu9dmvlbk7">
        <p className="mb-2 text-[13px] font-bold text-slate-800" data-id="element-169" data-mp="1yr6rnnzy2opo">{subject}</p>
        <div className="flex items-start gap-2" data-id="element-170" data-mp="6q1ixchxgt59">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white" style={{
          backgroundColor: color
        }} data-id="element-171" data-mp="bpw6b62hv0lk">
            {initials}
          </div>
          <div className="min-w-0 flex-1" data-id="element-172" data-mp="lfz0h9lcqklh">
            <div className="flex items-center justify-between gap-2" data-id="element-173" data-mp="lhs74ovyt4th">
              <p className="truncate text-[13px] font-semibold text-slate-800" data-id="element-174" data-mp="3jymocbrf7x07">
                {name}
              </p>
              <span className="shrink-0 text-[11px] text-slate-400" data-id="element-175" data-mp="3owo5us977o9k">{time}</span>
            </div>
            <p className="truncate text-[11px] text-slate-400" data-id="element-176" data-mp="3tu7jbpy2nx0g">
              para mí · {email}
            </p>
          </div>
        </div>
        <p className="mt-2 text-[13px] leading-relaxed text-slate-600" data-id="element-177" data-mp="195jtklb7yy8h">{body}</p>
        <div className="mt-2 flex items-center gap-0.5" data-id="element-178" data-mp="197mggwh2sb8z">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#f5b400] text-[#f5b400]" data-id="element-179" data-mp="3a79ab5c1mds6" data-mpi={i} />)}
        </div>
        <div className="mt-3 flex items-center gap-4 border-t border-slate-100 pt-2 text-[11px] text-slate-400" data-id="element-180" data-mp="357n074rihdnl">
          <span className="flex items-center gap-1" data-id="element-181" data-mp="3j7ei3gl5fe6v">
            <ReplyIcon className="h-3.5 w-3.5" data-id="element-182" data-mp="3f62m8tbolwq8" /> Responder
          </span>
          <span className="flex items-center gap-1" data-id="element-183" data-mp="2rh1df4yxsjkf">
            <ArchiveIcon className="h-3.5 w-3.5" data-id="element-184" data-mp="2rht5w6x8m16h" /> Archivar
          </span>
        </div>
      </div>
    </div>;
}